import { DUPE_API_URL } from '@dupe/common/constants'

const authenticator = async () => {
  try {
    const response = await fetch(`${DUPE_API_URL}/api/ik-auth`, {
      method: 'POST',
    })

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(
        `Request failed with status ${response.status}: ${errorText}`
      )
    }

    const data = await response.json()
    const { signature, expire, token } = data
    return { signature, expire, token }
  } catch (error: any) {
    throw new Error(`Authentication request failed: ${error.message}`)
  }
}

export default authenticator
